module.exports = __webpack_public_path__ + "img/diffLev.3fc702db.svg";